/* eslint-disable camelcase */

export default {
  action: {
    back: 'Retour',
    cancel: 'Annuler',
    close: 'Fermer',
    collapseDetails: 'Moins de détails',
    confirm: 'Valider',
    confirmAndInvite: 'Valider et inviter',
    continue: 'Continuer',
    createAccount: 'Création du compte',
    expandDetails: 'Plus de détails',
    invite: 'Inviter',
    logout: 'Déconnexion',
    no: 'Non',
    openSwitchOrganisation: 'Sélectionner une entreprise :',
    organisation: 'Entreprise',
    resendEmail: 'Renvoyer l‘email d‘activation',
    returnToHome: 'Aller vers la page d‘accueil',
    settings: 'Profil',
    skip: 'Ignorer',
    yes: 'Oui'
  },
  activateUser: {
    button: 'renvoyer l‘email d‘activation',
    emailSent: 'Nous avons envoyé un nouvel email',
    linkLabel: ' accéder à mon compte',
    message: 'Nous avons envoyé un email à %{email}',
    messageLink: 'J‘ai déjà cliqué sur le bouton, ',
    resendMessage: 'Je n‘ai pas reçu d‘email, ',
    subMessage: 'Veuillez cliquer sur le lien de confirmation pour activer votre compte.',
    title: 'Merci d‘avoir créé un compte sur OnceForAll'
  },
  address: {
    addressLine: 'Adresse',
    city: 'Ville',
    country: 'Pays',
    region: 'Région',
    postCode: 'Code postal',
    title: 'Adresse'
  },
  bdr: {
    access: {
      confirm: 'Accéder à Bâtisseur de Relations',
      collector: {
        text1: '__sBâtisseur de Relations : Une plateforme unique pour trouver vos futurs projets__s',
        text2: '__sVous cherchez un nouveau fournisseur pour un projet spécifique ?__s',
        text3: 'La plateforme Bâtisseur de Relations vous permet de :',
        text4: '  - Publier des projets et rechercher des fournisseurs selon vos critères et besoins.',
        text5: '  - Trouver des fournisseurs pré-qualifiés.',
        text6: '  - Assurer votre conformité pour toutes vos opérations.',
        text7: '__sGagnez du temps dans le sourcing et concentrez-vous sur votre cœur de métier grâce à Bâtisseur de Relations !__s',
        text8: 'Lors de votre connexion sur Bâtisseur de Relations, votre compte utilisateur et vos entreprises sur OnceForAll seront automatiquement synchronisés.'
      },
      depositor: {
        text1: '__sBâtisseur de Relations : Une plateforme unique pour trouver vos futurs projets__s',
        text2: '__sVous souhaitez développer votre activité ?__s',
        text3: 'La plateforme Bâtisseur de Relations vous permet de :',
        text4: '  - Rechercher et consulter des appels d‘offres publics',
        text5: '  - Recevoir des projets de la part de donneurs d‘ordres privés',
        text6: '  - Être référencé sur le plus grand réseau d‘entreprises du BTP en France.',
        text7: '__sGagnez du temps sur la recherche de projets et remportez de nouveaux contrats avec Bâtisseur de Relations !__s',
        text8: 'Lors de votre connexion sur Bâtisseur de Relations, votre compte utilisateur et vos entreprises sur OnceForAll seront automatiquement synchronisés.'
      }
    },
    discover: {
      collector: {
        dashboard: {
          text: 'Trouvez des fournisseurs qualifiés pour vos futurs projets parmi le plus important réseau d‘entreprises du BTP en France'
        },
        other: {
          text: 'Trouvez des fournisseurs qualifiés pour vos futurs projets parmi le plus important réseau d‘entreprises du BTP en France'
        }
      },
      confirm: 'Testez maintenant',
      depositor: {
        text: 'Trouvez de nouvelles opportunités commerciales publiques et privées sur une plateforme unique et faites grandir votre business !'
      },
      title: '__sBâtisseur de Relations :__s'
    },
    errorNoUserAndBdrService: {
      text1: 'Une erreur est survenue lors de la création de votre profil Marketplace. Nous vous prions de bien vouloir nous excuser pour le désagrément.',
      text2: 'Veuillez nous en informer à l\'adresse suivante : <a href="mailto:service.clients@onceforall.fr" title="mailto:service.clients@onceforall.fr">service.clients@onceforall.fr</a>.',
      text3: 'À très vite sur notre plateforme, l\'équipe Once For All.'
    },
    errorNoBdrService: {
      text1: 'Votre offre actuelle ne vous permet pas d’accéder à ce service. Nous vous prions de bien vouloir nous excuser pour le désagrément.',
      text2: '👉 <a href="/alg/organisation/subscription">Voir mon offre</a>',
      text3: 'À très vite sur notre plateforme.'
    }
  },
  banette: {
    documentName: 'Nom du document',
    explanatoryTooltip: 'Les documents chargés dans cette "Bannette" seront visibles par l‘ensemble des entreprises de l‘opération',
    noDocument: 'Aucun document n‘est actuellement dans votre liste.',
    pleaseAddDocument: 'Veuillez cliquer sur "+" pour ajouter un document à votre bannette opération.',
    requireCCRD: 'Demander Attestation Décennale Nominative',
    requireCRSE: 'Demander Charte RSE',
    uploadNewDocument: 'Déposer un document',
    widgetTitle: 'Bannette'
  },
  client: {
    accessCode: {
      additionalInformation: 'Informations complémentaires',
      clientOrgName: 'Raison sociale de l‘entreprise invitée',
      generateButton: 'Générer un code d‘accès',
      generateText: 'Générer un code d‘accès',
      generateWarning: 'Seuls les clients français peuvent être invités.',
      responseToAccessCode: 'Réponse à un appel d‘offre',
      tenderReference: 'Référence de l‘appel d‘offre'
    },
    add: {
      button: 'Ajouter un client',
      inviteSuccess: 'L‘entreprise %{name} a été ajoutée à votre liste de clients !',
      notice: 'Vous partagez vos documents avec les clients que vous invitez.',
      title: 'Ajouter un client'
    },
    documents: 'Mes documents pour %{clientName}',
    invitations: {
      actions: {
        accept: 'Accepter',
        decline: 'Décliner',
        resend: 'Inviter à nouveau',
        tooltip: 'Vous devez attendre %{count} jours pour renvoyer cette invitation'
      },
      noSent: 'Aucune invitation à afficher',
      received: 'Invitations reçues',
      sent: 'Invitations envoyées'
    },
    invite: {
      defaultMessage: '%{userName} de la société %{organisationName} vous invite à rejoindre la plateforme OnceForAll d‘Attestation Légale afin de faciliter la gestion de vos fournisseurs (Kbis, attestation sociale de vigilance, liste des salariés étrangers, etc.).\nLeader sur son marché, Attestation Légale a vocation à faciliter les relations entre les acteurs de la Construction et de l‘Immobilier. Grâce à la solution OnceForAll, vous accédez en toute sécurité aux dossiers uniques, toujours complets et à jour de vos fournisseurs.\n\nDès que vous serez inscrit, vous pourrez accéder gratuitement et à tout moment au dossier administratif de la société %{organisationName}.',
      inviteSuccess: 'Une fois que la personne invitée se sera inscrite sur OnceForAll et qu‘elle aura ajouté son entreprise, cette dernière sera automatiquement liée à la vôtre en tant que client.',
      title: 'Inviter un client'
    },
    myClients: 'Clients',
    relationshipAccepted: 'L‘invitation de votre client a été acceptée !',
    relationshipAlreadyReplied: 'Vous avez déjà répondu à l‘invitation',
    relationshipRejected: 'L‘invitation de votre client a été déclinée !',
    search: {
      notFound: 'Aucun client trouvé'
    }
  },
  contact: {
    content: 'Vous souhaitez préciser votre demande',
    creationSuccess: 'Votre demande a été prise en compte',
    email: 'kontakt.de@onceforall.com',
    horary: {
      alg_fr: 'Ouvert du lundi au jeudi de 8h30 à 12h30 et de 13h30 à 18h et le vendredi, de 8h30 à 12h30 et de 13h30 à 17h',
      ofa_de: 'Ouvert du lundi au vendredi de 9h à 17h',
      ofa_it: 'Ouvert du lundi au jeudi de 8h30 à 12h30 et de 13h30 à 18h et le vendredi, de 8h30 à 12h30 et de 13h30 à 17h'
    },
    phone: {
      alg_fr: '+33 4 72 38 32 58',
      ofa_de: '+49 30 397 160 82',
      ofa_it: '+39 02 3056 9038'
    },
    subtype: 'Et plus spécifiquement',
    title: 'Nous contacter',
    type: 'Votre demande concerne',
    types: {
      FileClaim: 'Faire une réclamation',
      IdeaSuggestion: 'Proposer une idée, un témoignage',
      MyCustomers: 'Mes clients',
      MyDocuments: 'Mes documents',
      MyOffer: 'Mon offre',
      MyProjects: 'Mes opérations',
      MyReferencesList: 'Ma liste de références chantier',
      MyRole: 'Mon rôle',
      MySettings: 'Mes paramètres',
      MySuppliers: 'Mes fournisseurs',
      MyTraining: 'Ma formation'
    }
  },
  country: {
    ANDORRA: 'Andorre',
    AUSTRIA: 'Autriche',
    BELGIUM: 'Belgique',
    BOLIVIA: 'Bolivie',
    BULGARIA: 'Bulgarie',
    CROATIA: 'Croatie',
    CZECH_REPUBLIC: 'République Tchèque',
    DENMARK: 'Danemark',
    ESTONIA: 'Estonie',
    FRANCE: 'France',
    GERMANY: 'Allemagne',
    GREECE: 'Grèce',
    HUNGARY: 'Hongrie',
    ICELAND: 'Islande',
    INDIA: 'Inde',
    ITALY: 'Italie',
    IVORY_COAST: 'Côte d‘ivoire',
    LATVIA: 'Lettonie',
    LITHUANIA: 'Lithuanie',
    LUXEMBOURG: 'Luxembourg',
    MAURITIUS: 'Maurice',
    MEXICO: 'Mexique',
    MONACO: 'Monaco',
    NETHERLANDS: 'Pays Bas',
    POLAND: 'Pologne',
    PORTUGAL: 'Portugal',
    ROMANIA: 'Roumanie',
    SERBIA: 'Serbie',
    SLOVAKIA: 'Slovaquie',
    SLOVENIA: 'Slovénie',
    SPAIN: 'Espagne',
    SWEDEN: 'Suède',
    SWITZERLAND: 'Suisse',
    UNITED_KINGDOM: 'Royaume-Uni',
    flags: {
      AD: 'Andorre',
      AT: 'Autriche',
      BE: 'Belgique',
      BG: 'Bulgarie',
      BO: 'Bolivie',
      CH: 'Suisse',
      CI: 'Côte d‘ivoire',
      CZ: 'République Tchèque',
      DE: 'Allemagne',
      DK: 'Danemark',
      EE: 'Estonie',
      ES: 'Espagne',
      FR: 'France',
      GB: 'Royaume-Uni',
      GR: 'Grèce',
      HR: 'Croatie',
      HU: 'Hongrie',
      IN: 'Inde',
      INTERNATIONAL: 'International',
      IS: 'Islande',
      IT: 'Italie',
      LT: 'Lituanie',
      LU: 'Luxembourg',
      LV: 'Lettonie',
      MC: 'Monaco',
      MU: 'Maurice',
      MX: 'Mexique',
      NL: 'Pays Bas',
      PL: 'Pologne',
      PT: 'Portugal',
      RO: 'Roumanie',
      RS: 'Serbie',
      SE: 'Suède',
      SI: 'Slovénie',
      SK: 'Slovaquie'
    }
  },
  dashboard: {
    deactivated: {
      action: 'Nous contacter',
      message: 'Veuillez nous contacter si vous souhaitez réactiver votre établissement et renouveler votre offre.',
      title: 'Votre entreprise est désactivée'
    },
    documents: 'Documents',
    documentsToProcess: {
      action: {
        sign: 'Signer ce document',
        upload: 'Déposer ce document'
      },
      emptyList: 'Tous vos documents ont été traités',
      expandList: 'Voir tous les documents à traiter',
      message: {
        AWAITING_SIGNATURE: 'doit être signé',
        EXPIRED: 'est expiré depuis le %{expirationDate}',
        MISSING: 'est manquant',
        REJECTED: 'a été rejeté pour la raison suivante :'
      },
      title: 'Documents à traiter'
    },
    stats: {
      clients: 'Clients',
      link: {
        clients: 'Voir tous les clients',
        projects: 'Voir toutes les opérations',
        subcontractors: 'Voir tous les fournisseurs',
        users: 'Voir tous les utilisateurs'
      },
      projects: 'Opérations',
      subcontractors: {
        nationality: {
          FRANCE: 'français',
          GERMANY: 'allemand',
          ITALY: 'italien'
        },
        title: 'Fournisseurs',
        valid: 'des fournisseurs de cette entreprise ont un quitus %{nationality} valide'
      },
      users: 'Utilisateurs'
    }
  },
  datetime: {
    datePickerMask: [
      'd',
      'd',
      '/',
      'd',
      'd',
      '/',
      'd',
      'd',
      'd',
      'd'
    ],
    shortDate: 'DD/MM/YYYY',
    shortDatetime: 'DD/MM/YYYY HH:mm',
    undefined: '-'
  },
  document: {
    addAdditionalDesignation: 'Ajouter une désignation supplémentaire',
    additionalDesignation: 'Désignation supplémentaire',
    additionalDesignationNotice: 'Utilisée pour différencier deux documents du même type',
    additionalDesignationSuccessUpdate: 'La désignation supplémentaire a été mise à jour avec succès',
    all: 'Tous les documents',
    canNotDownload: 'Ce document ne peut pas être téléchargé.',
    changeFile: 'Changer de fichier',
    chart: {
      almostExpired: 'documents bientôt expirés',
      almostExpired_1: 'document bientôt expiré',
      awaiting: 'documents en cours de traitement',
      awaiting_1: 'document en cours de traitement',
      percentageLabel: 'Valides',
      seeMyDocuments: 'Voir mes documents',
      title: 'État de mes documents',
      todo: 'documents à traiter',
      todo_1: 'document à traiter',
      valid: 'documents valides',
      valid_1: 'document valide'
    },
    checkFile: 'Vérifier le document',
    chooseOnComputer: 'Choisissez sur votre ordinateur',
    collectionMandateEnabled: {
      FRANCE: 'Collecté par Attestation Légale',
      GERMANY: 'Collecté par OnceForAll'
    },
    consultMyArchivedDocuments: 'Consulter mes archives',
    consultMyDocuments: 'Retour aux documents',
    delete: 'Supprimer',
    documentDetails: {
      addNewVersion: 'Ajouter une nouvelle version',
      documentExample: 'cliquer pour voir un modèle du document attendu',
      documentIsGathered: {
        FRANCE: 'Ce document est collecté par Attestation Légale.',
        GERMANY: 'Ce document est collecté par OnceForAll'
      },
      documentIsRejected: 'Le document a été refusé, cliquer pour avoir plus de détails.',
      documentVersionIsAwaitingSignature: 'Une version du document est en attente de signature, cliquer pour avoir plus de détails.',
      documentVersionIsRejected: 'Une version du document a été refusée, cliquer pour avoir plus de détails.',
      emptyTimeline: 'Ce document n‘a pas encore de version valide',
      noPastDocument: 'Aucune archive pour ce document',
      noPresentDocument: 'Aucune version valide à ce jour',
      noPresentDocumentAtDate: 'Aucune version valide à date de DOC : %{projectOpeningDate}',
      noPresentDocumentAtInterventionDate: 'Aucune version valide à date de début d‘intervention : %{interventionDate}',
      noPresentDocumentAtInterventionDateTooltip: 'Le statut est calculé sur la date de début d‘intervention car cette organisation a été créée après la date d‘ouverture du chantier.',
      showTimelineButton: 'Voir toutes les versions valides',
      state: {
        ALMOST_EXPIRED: 'Valide, expire %{time}',
        AWAITING_COMPLETION: 'En attente de renseignement',
        AWAITING_GATHERING: 'En cours de collecte',
        AWAITING_SIGNATURE: 'En attente de signature',
        AWAITING_VALIDATION: 'En attente de vérification',
        CREATED: 'Inconnu',
        EXPIRED: 'Expiré %{time}',
        MISSING: 'Manquant',
        NOT_APPLICABLE: 'Non applicable',
        REJECTED: 'Refusé',
        SIGNED: 'Signé, valide%{until}',
        VALID: 'Valide%{until}'
      },
      timeline: 'Chronologie des versions du document',
      unpublished: 'Document archivé',
      validityEndLineForValid: ' jusqu‘au %{validityEnd}'
    },
    documentType: 'Type de document',
    documentVersion: {
      ongoingLabel: 'En cours',
      rejectionReason: ' Motif : <span class="error">%{rejectionReason}</span>',
      state: {
        ALMOST_EXPIRED: '<strong class="warning">bientôt expirée</strong>',
        AWAITING_GATHERING: '<strong class="ofa">en attente de collecte</strong>',
        AWAITING_SIGNATURE: '<strong class="error">en attente de signature</strong>',
        AWAITING_VALIDATION: '<strong class="ofa">en attente de vérification</strong>',
        EXPIRED: '<strong class="success">valide</strong>',
        MISSING: '<strong class="error">manquante</strong>',
        NOT_APPLICABLE: '<strong class="information">non applicable</strong>',
        REJECTED: '<strong class="error">refusée</strong>.',
        SIGNED: '<strong class="success">signée et valide</strong>',
        VALID: '<strong class="success">valide</strong>'
      },
      stateLine: {
        CURRENT: 'Cette version du document est %{state}',
        FUTURE: 'Cette version du document sera %{state}',
        PAST: 'Cette version du document était %{state}'
      },
      validityEndLine: ' jusqu‘au <strong>%{validityEnd}</strong>',
      validityFullLine: ' entre le <strong>%{validityStart}</strong> et le <strong>%{validityEnd}</strong>',
      validityStartLine: ' à partir du <strong>%{validityStart}</strong>'
    },
    dossierResume: {
      documentAlmostExpiredText: 'Le document suivant va bientôt expirer : ',
      documentInvalidInProgressText: 'Un document est en cours de traitement par Attestation Légale.',
      documentInvalidText: 'Vous devez traiter le document suivant : ',
      documentsAlmostExpiredText: 'Les documents suivants vont bientôt expirer : ',
      documentsInvalidsInProgressText: 'Des documents sont en cours de traitement par Attestation Légale.',
      documentsInvalidsText: 'Vous devez traiter les documents suivants : ',
      download: 'Télécharger le quitus',
      title: {
        AWAITING_VERIFICATION: 'Votre quitus est en cours de vérification',
        INVALID: 'Votre quitus est invalide',
        VALID: 'Votre quitus est valide',
        WARNING: 'Votre quitus est valide, mais bientôt expiré'
      }
    },
    downloadExcelTemplate: 'Télécharger le modèle Excel',
    downloadExcelTemplateMessage: 'Veuillez commencer par télécharger le modèle Excel',
    downloadTemplate: 'Télécharger le modèle',
    downloadTemplateMessage: 'Veuillez commencer par télécharger le modèle',
    dragDropHere: 'Glisser et déposer ici votre document',
    duplicate: 'Dupliquer',
    editAdditionalDesignation: 'Modifier la désignation supplémentaire',
    errorMaxSizeMessage: 'La taille maximale est de %{count}MB',
    errorMinSizeMessage: 'La taille minimale est de %{count}KB',
    errorTypeMessage: 'Le fichier doit être au(x) format(s) suivant(s) : ',
    fileSize: 'Taille du fichier',
    filename: 'Nom du fichier',
    foreignEmployees: {
      secondaryUploadMessage: 'Formats disponibles : Excel et PDF (Si vous téléchargez un document PDF, l‘équipe Attestation Légale va transcrire cette liste de salariés en fichier Excel et la téléchargera à votre place.)',
      uploadMessage: {
        bullet1: 'Les salariés de l‘Espace Économique Européen',
        bullet2: 'Les intérimaires',
        line1: 'Ne sont pas soumis à déclaration :',
        line2: 'Les informations fournies seront vérifiées par l‘équipe Attestation Légale.\nVeuillez vous assurer que les informations de votre document soient correctes et suffisamment lisibles.'
      }
    },
    header: {
      dossiers: 'Dossiers',
      name: 'Nom',
      reminderStatus: 'Statut à la relance',
      status: 'Statut',
      validityPeriod: 'Période de validité'
    },
    issueDate: 'Date d‘émission',
    myArchivedDocuments: 'Archives',
    myDocuments: 'Documents',
    myTodoDocuments: 'A traiter',
    noArchive: 'Aucune archive',
    noDocumentMessage: 'Afin de pouvoir déposer vos documents, veuillez ajouter un client.',
    noForeignWorkers: 'Je n‘ai pas de salariés étrangers',
    noResultMatch: 'Aucun résultat ne correspond à votre recherche',
    noSignPermission: 'Seul le responsable légal de l‘entreprise peut signer ce document',
    noTodo: 'Vous n‘avez aucun document à déposer',
    notDepositor: 'Veuillez nous contacter pour activer le service déposant de votre établissement.',
    open: 'Ouvrir',
    openExcel: 'Ouvrir le fichier Excel',
    openProof: 'Ouvrir l‘authentification',
    payrollRatio: {
      NC: 'Non communiqué',
      label: 'Ratio de masse salariale :'
    },
    planUpgradable: 'Vous devez changer d‘offre pour déposer des documents et inviter des clients.',
    remind: {
      additionalContext: 'Précisez le contexte de votre relance',
      command: {
        title: 'Relancer le dossier'
      },
      context: 'Contexte',
      description: {
        additionalContext: 'Contexte additionnel :',
        dateFrom: 'Relance du %{date}',
        emptyMessage: 'Aucune relance à afficher',
        projectName: 'Nom de l‘opération :',
        reason: {
          APPLICATION_APPROVAL: 'Demande d‘agrément',
          CONTRACT: 'Contrat',
          CREATION_ADDITIONAL_DOCUMENT: 'Création document additionnel',
          END_OF_PROJECT: 'Fin d‘opération',
          PAYMENT: 'Paiement',
          PRIVATE_MARKET: 'Marché privé',
          PUBLIC_MARKET: 'Marché public',
          REPORT_ANOMALY: 'Signaler une anomalie',
          SIGNATURE: 'Signature',
          title: 'Motif :'
        }
      },
      documents: {
        error: 'Vous devez sélectionner un document',
        title: 'Documents à relancer'
      },
      information: 'Si malgré les relances préventives emails et téléphoniques réalisées par Attestation Légale, le dossier ne dispose pas des documents attendus, ce service vous permet de déclencher une mise en demeure téléphonique de votre fournisseur sur la base du contexte que vous nous communiquez ci-dessous.<br /><br />Nous vous tiendrons personnellement informé(e) du suivi de cette demande.',
      reason: {
        APPLICATION_APPROVAL: 'demander l‘agrément',
        CONTRACT: 'conserver le dossier à jour',
        CREATION_ADDITIONAL_DOCUMENT: 'obtenir un type de document complémentaire',
        PAYMENT: 'payer la facture',
        REPORT_ANOMALY: 'corriger une anomalie sur les documents',
        SIGNATURE: 'signer le contrat',
        name: 'Motif de ma demande'
      },
      subMessageProject: 'Dans le cadre de l‘opération',
      subMessageReason: 'je souhaite obtenir la mise à jour de ses documents pour',
      success: 'La Relance Documentaire a été prise en compte. Vous allez recevoir une copie par email.',
      title: 'Demande de relance complémentaire'
    },
    searchArchiveBar: 'Nom du document',
    searchBar: 'Nom du document',
    seeExample: 'Voir un exemple',
    sign: 'Signer',
    signWaitingText: 'Veuillez patienter, vous allez être redirigé vers notre fournisseur de signature électronique...',
    staff: 'Employés :',
    state: {
      ALMOST_EXPIRED: 'Bientôt expiré',
      AWAITING_COMPLETION: 'En attente de renseignement',
      AWAITING_GATHERING: 'En cours de collecte',
      AWAITING_SIGNATURE: 'En attente de signature',
      AWAITING_VALIDATION: 'En attente de vérification',
      CREATED: 'Inconnu',
      EXPIRED: 'Expiré',
      MISSING: 'Manquant',
      NOT_APPLICABLE: 'Non applicable',
      REJECTED: 'Refusé',
      SIGNED: 'Signé',
      VALID: 'Valide'
    },
    upload: 'Déposer',
    uploadMessage: {
      FRANCE: 'Si votre document n‘est pas en __sfrançais__s, veuillez déposer un fichier contenant le document original et sa __straduction__s en français.',
      GERMANY: 'Si votre document n‘est pas en __sallemand__s, veuillez déposer un fichier contenant le document original et sa __straduction__s en allemand.'
    },
    uploadSuccess: 'Votre fichier a été bien déposé',
    uploadUpdate: 'Mettre à jour',
    valid: 'Documents valides',
    validityPeriod: 'Du %{startDate} au %{endDate}',
    waiting: 'Documents à déposer'
  },
  documentType: {
    search: {
      alreadyRequired: 'Ce type de document est déjà requis',
      notfound: 'Ce type de document n‘existe pas',
      placeholder: 'Rechercher un type de document'
    }
  },
  dossier: {
    add: 'Ajouter un document',
    addLabel: 'Sélectionner un document',
    addSuccessful: 'Le document a bien été ajouté',
    countryLabel: 'Dossier ',
    download: {
      all: 'Télécharger le dossier',
      dossierOverview: 'Télécharger le quitus',
      standard: 'Télécharger le dossier',
      standardArchives: 'Télécharger toutes les archives'
    },
    interoperated: 'Dossier interopéré',
    labels: {
      ADDITIONAL: 'Additionnel',
      BUSINESS: {
        ALL: 'Métier',
        CLEANING: 'Nettoyage',
        CONSTRUCTION: 'BTP',
        SAFETY: 'Sécurité privée',
        TEMPORARY_WORK: 'Travail temporaire',
        TRANSPORTATION: 'Transports'
      },
      LEGAL: 'Légal',
      PROJECT: 'Opérations'
    },
    print: {
      all: 'Imprimer le dossier',
      standard: 'Imprimer le dossier'
    },
    projects: 'Opérations',
    relatedProjects: 'Opérations associées',
    state: {
      AWAITING_VERIFICATION: {
        fullLabel: 'Quitus en cours de vérification',
        shortLabel: 'En cours de vérification'
      },
      DEPOSITOR_SERVICE_DEACTIVATED: {
        fullLabel: 'Service déposant non activé',
        shortLabel: 'Service déposant non activé'
      },
      EMPTY: {
        fullLabel: 'Aucun document pour le pays sélectionné',
        shortLabel: 'Aucun document pour le pays sélectionné'
      },
      INVALID: {
        fullLabel: 'Quitus invalide',
        shortLabel: 'Invalide'
      },
      UNKNOWN: {
        fullLabel: 'Le statut du quitus n‘est pas encore disponible',
        shortLabel: 'Non disponible'
      },
      VALID: {
        fullLabel: 'Quitus valide',
        shortLabel: 'Valide'
      },
      WARNING: {
        fullLabel: 'Quitus valide, mais bientôt expiré',
        shortLabel: 'Valide, mais bientôt expiré'
      },
      title: 'Statut du quitus'
    }
  },
  error: {
    CGURequired: 'Les CGU doivent être acceptées',
    clientAlreadyExists: 'Impossible d‘ajouter plus d‘un maître d‘ouvrage, veuillez vérifier votre saisie',
    dateShouldBeBefore: 'Une intervention débute avant la nouvelle date d‘ouverture de chantier !',
    emailConfirmation: 'L‘email de confirmation ne correspond pas à l‘email renseigné',
    generic: 'Une erreur est survenue',
    interventionAlreadyEnded: 'Vous êtes déjà lié à cette entreprise dans cette opération',
    invalidEmailFormat: 'Le format de l‘email est erroné',
    invalidIdentificationNumber: 'Numéro d‘identification invalide',
    invalidMobilePhoneNumber: 'Le format du numéro de téléphone mobile est erroné',
    invalidNumberFormat: 'Ce champ doit contenir des chiffres',
    invalidPhoneNumber: 'Le format du numéro de téléphone est erroné',
    invalidRegistrationNumber: 'Numéro d‘identification invalide',
    notYetSupported: 'Cette fonctionnalité n‘est pas encore disponible',
    organisationAlreadyExists: 'Vous êtes déjà lié à cette entreprise dans cette opération',
    organisationNotFound: 'Aucune entreprise n‘existe avec ce numéro de SIRET',
    passwordConfirmation: 'Le mot de passe de confirmation ne correspond pas au mot de passe renseigné',
    privacyPolicyRequired: 'La politique de confidentialité doit être acceptée',
    registrationNumberAlreadyExists: 'Ce numéro d‘identification existe déjà',
    required: 'Ce champ est requis',
    userAlreadyExist: 'Un compte avec cette adresse email existe déjà',
    validation: 'La valeur saisie n‘est pas valide'
  },
  errorPage: {
    contactEmail: 'service.clients@onceforall.com',
    buttonLabel: 'Rafraîchir la page',
    subtitle: 'Veuillez nous excuser, une erreur s‘est produite dans l‘application. Nous essayons actuellement de résoudre le problème.',
    text: 'Si le problème persiste, vous pouvez nous contacter à ',
    title: 'ERREUR'
  },
  favoriteRelationship: {
    add: 'Ajouter aux favoris',
    message: {
      add: '%{organisationName} a été ajouté aux favoris',
      remove: '%{organisationName} a été retiré des favoris'
    },
    remove: 'Retirer des favoris'
  },
  globalDashboard: {
    documents: 'Documents de mes fournisseurs',
    documentsStillValid: 'encore valides',
    myOrganisations: 'Mes établissements',
    mySubcontractors: 'Mes fournisseurs',
    organisationRegistrationSuccessful: {
      line1: 'Votre demande est en cours de traitement.',
      line2: 'Vous serez notifié par email une fois le traitement de votre demande terminé.'
    },
    quitus: 'Quitus de mes fournisseurs',
    quitusDescription: 'de mes fournisseurs ont un quitus valide',
    seeAllSubcontractors: 'Voir tous mes fournisseurs actifs',
    subcontractorsLabel: 'Fournisseurs actifs'
  },
  globalSubcontractor: {
    noSubcontractors: 'Aucun fournisseurs',
    selectClientForSubcontractor: 'Toutes vos organisations avec le fournisseur %{subcontractorName} :',
    title: 'Tous mes fournisseurs'
  },
  helpCenter: {
    aQuestion: 'Une question ?',
    category: {
      ACCESS: 'Mes accès',
      CLIENT: 'Mes clients',
      DOCUMENT: 'Mes documents',
      MODEL: 'Mes modèles',
      OPTION: 'Mes options',
      PARAMETER: 'Mes paramètres',
      PROJECT: 'Mes opérations',
      SUBCONTRACTOR: 'Mes fournisseurs'
    },
    contactCustomerService: 'Vous n‘avez pas trouvé votre réponse ? Veuillez',
    contactCustomerServiceLink: 'contacter le service client.',
    helpCenterButton: 'Voir la page Aide et Contact',
    selectACategory: 'Sélectionner une catégorie :',
    title: 'Aide et Contact'
  },
  identificationNumber: {
    ANDORRA: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numéro à 11 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numéro à 11 chiffres'
      }
    },
    AUSTRIA: {
      REGISTRATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        tooltip: 'ATU + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (TVA intra)',
        tooltip: 'ATU + Numéro à 8 chiffres'
      }
    },
    BELGIUM: {
      REGISTRATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA',
        tooltip: 'BE + Numéro à 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA',
        tooltip: 'BE + Numéro à 10 chiffres'
      }
    },
    BOLIVIA: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Tributaria',
        tooltip: 'Numéro à 8 à 12 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Tributaria (TVA intra)',
        tooltip: 'Numéro à 8 à 12 chiffres'
      }
    },
    BULGARIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS',
        tooltip: 'BG + Numéro à 9 ou 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS (TVA intra)',
        tooltip: 'BG + Numéro à 9 ou 10 chiffres'
      }
    },
    CROATIA: {
      REGISTRATION_NUMBER: {
        name: 'PDV Id. Broj OIB',
        tooltip: 'HR + Numéro à 11 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PDV Id. Broj OIB (TVA intra)',
        tooltip: 'HR + Numéro à 11 chiffres'
      }
    },
    CZECH_REPUBLIC: {
      REGISTRATION_NUMBER: {
        name: 'Daňové identifikační číslo',
        tooltip: 'CZ + Numéro de 8 à 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Daňové identifikační číslo (TVA intra)',
        tooltip: 'CZ + Numéro de 8 à 10 chiffres'
      }
    },
    DENMARK: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'DK + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (TVA intra)',
        tooltip: 'DK + Numéro à 8 chiffres'
      }
    },
    ESTONIA: {
      REGISTRATION_NUMBER: {
        name: 'Käibemaksukohustuslase number',
        tooltip: 'EE + Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Käibemaksukohustuslase number (TVA intra)',
        tooltip: 'EE + Numéro à 9 chiffres'
      }
    },
    FRANCE: {
      GROUP_NUMBER: {
        name: 'SIREN',
        tooltip: 'Numéro à 9 chiffres'
      },
      REGISTRATION_NUMBER: {
        name: 'SIRET',
        tooltip: 'Numéro à 14 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numéro à 11 chiffres'
      }
    },
    GERMANY: {
      REGISTRATION_NUMBER: {
        name: 'Betriebsnummer',
        tooltip: 'Numéro à 8 chiffres'
      },
      STEUERLICHE_IDENTIFIKATIONSNUMMER: {
        name: 'Steuerliche Identifikationsnummer',
        shortName: 'Steuernummer',
        tooltip: 'Numéro à 11 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (TVA intra)',
        shortName: 'Ust.-ID',
        tooltip: 'DE + Numéro à 9 chiffres'
      }
    },
    GREECE: {
      REGISTRATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou',
        tooltip: 'EL + Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou (TVA intra)',
        tooltip: 'EL + Numéro à 9 chiffres'
      }
    },
    HUNGARY: {
      REGISTRATION_NUMBER: {
        name: 'Közösségi adószám',
        tooltip: 'HU + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Közösségi adószám (TVA intra)',
        tooltip: 'HU + Numéro à 8 chiffres'
      }
    },
    ICELAND: {
      REGISTRATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer',
        tooltip: 'IS + Numéro à 6 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer (TVA intra)',
        tooltip: 'IS + Numéro à 6 chiffres'
      }
    },
    INDIA: {
      REGISTRATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN',
        tooltip: 'IN + Numéro à 11 chiffres + V'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN (TVA intra)',
        tooltip: 'IN + Numéro à 11 chiffres + V'
      }
    },
    ITALY: {
      REGISTRATION_NUMBER: {
        name: 'Codice Fiscale',
        tooltip: 'Numéro à 11 chiffres pour les entreprises ou code à 16 caractères pour les personnes'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Partita IVA (TVA intra)',
        tooltip: 'IT + Numéro à 11 chiffres'
      }
    },
    IVORY_COAST: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'CI + Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (TVA intra)',
        tooltip: 'CI + Numéro à 9 chiffres'
      }
    },
    LATVIA: {
      REGISTRATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
        tooltip: 'LV + Numéro à 11 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs (TVA intra)',
        tooltip: 'LV + Numéro à 11 chiffres'
      }
    },
    LITHUANIA: {
      REGISTRATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas',
        tooltip: 'LT + Numéro à 9 ou 12 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas (TVA intra)',
        tooltip: 'LT + Numéro à 9 ou 12 chiffres'
      }
    },
    LUXEMBOURG: {
      REGISTRATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + Numéro à 8 chiffres'
      }
    },
    MAURITIUS: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'MU + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (TVA intra)',
        tooltip: 'MU + Numéro à 8 chiffres'
      }
    },
    MEXICO: {
      REGISTRATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes',
        tooltip: '3 ou 4-caractères + 6 chiffres + 3 caractères'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes (TVA intra)',
        tooltip: '3 ou 4-caractères + 6 chiffres + 3 caractères'
      }
    },
    MONACO: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numéro à 11 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numéro à 11 chiffres'
      }
    },
    NETHERLANDS: {
      REGISTRATION_NUMBER: {
        name: 'Btw-nummer',
        tooltip: 'NL + 9 chiffres + B + 2 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Btw-nummer (TVA intra)',
        tooltip: 'NL + 9 chiffres + B + 2 chiffres'
      }
    },
    POLAND: {
      REGISTRATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej',
        tooltip: 'PL + Numéro à 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej (TVA intra)',
        tooltip: 'PL + Numéro à 10 chiffres'
      }
    },
    PORTUGAL: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva',
        tooltip: 'PT + Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva (TVA intra)',
        tooltip: 'PT + Numéro à 9 chiffres'
      }
    },
    ROMANIA: {
      REGISTRATION_NUMBER: {
        name: 'Codul de identificare fiscală',
        tooltip: 'RO + Numéro de 2 à 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Codul de identificare fiscală (TVA intra)',
        tooltip: 'RO + Numéro de 2 à 10 chiffres'
      }
    },
    SERBIA: {
      REGISTRATION_NUMBER: {
        name: 'Poreski identifikacioni broj',
        tooltip: 'Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Poreski identifikacioni broj (TVA intra)',
        tooltip: 'Numéro à 9 chiffres'
      }
    },
    SLOVAKIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty',
        tooltip: 'SK + Numéro à 10 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty (TVA intra)',
        tooltip: 'SK + Numéro à 10 chiffres'
      }
    },
    SLOVENIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacijska številka za DDV',
        tooltip: 'SI + Numéro à 8 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacijska številka za DDV (TVA intra)',
        tooltip: 'SI + Numéro à 8 chiffres'
      }
    },
    SPAIN: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Fiscal',
        tooltip: 'ES + 1 caractère + 7 chiffres + 1 caractère'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Fiscal (TVA intra)',
        tooltip: 'ES + 1 caractère + 7 chiffres + 1 caractère'
      }
    },
    SWEDEN: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'SE + Numéro à 12 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (TVA intra)',
        tooltip: 'SE + Numéro à 12 chiffres'
      }
    },
    SWITZERLAND: {
      REGISTRATION_NUMBER: {
        name: 'Mehrwertsteuernummer',
        tooltip: 'CHE + Numéro à 9 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Mehrwertsteuernummer (TVA intra)',
        tooltip: 'CHE + Numéro à 9 chiffres'
      }
    },
    UNITED_KINGDOM: {
      REGISTRATION_NUMBER: {
        name: 'Value added tax registration number',
        tooltip: 'GB + 9 or 12 chiffres / GBGD + 3 chiffres / GBHA + 3 chiffres'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value added tax registration number (TVA intra)',
        tooltip: 'GB + 9 or 12 chiffres / GBGD + 3 chiffres / GBHA + 3 chiffres'
      }
    }
  },
  initialLoading: {
    error: 'Nous sommes désolés de l‘attente. Nos développeurs vont analyser le problème.',
    message: 'Un instant, OnceForAll démarre ...'
  },
  intervention: {
    dateForm: {
      error: 'La date ne peut pas être antérieure à celle de l‘ouverture de l‘opération',
      fieldLabel: 'Date',
      openButton: 'Spécifier une date d‘intervention',
      saveSuccess: 'La date d‘intervention a été sauvegardée',
      title: 'Spécifier une date d‘intervention'
    },
    ended: {
      buttonTitle: 'Mettre fin à l‘intervention de cette entreprise',
      confirmEndOrganisation: {
        content: 'Êtes-vous sûr de vouloir mettre fin à la participation de %{organisationName} au projet?',
        warning: 'Cette entreprise et ses sous-traitants ne pourront plus accéder au projet'
      },
      endSuccess: '%{organisationName} ne fait plus partie de l‘opération',
      name: ' (terminé)',
      tooltip: 'L‘intervention de cette entreprise a été terminée le %{endDate}'
    },
    invited: {
      external: {
        CLIENT: 'En attente de l‘inscription du maitre d‘ouvrage',
        GENERAL_CONTRACTOR: 'En attente de l‘inscription de l‘entreprise principale',
        PROJECT_MANAGER: 'En attente de l‘inscription du maître d‘oeuvre',
        PROJECT_MANAGER_CLIENT: 'En attente de l‘inscription du maître d‘oeuvre',
        SERVICE_PROVIDER: 'En attente de l‘inscription du prestataire',
        SUB_CONTRACTOR: 'En attente de l‘inscription du client'
      },
      internal: {
        CLIENT: 'En attente de l‘acceptation du maitre d‘ouvrage',
        GENERAL_CONTRACTOR: 'En attente de l‘acceptation de l‘entreprise principale',
        PROJECT_MANAGER: 'En attente de l‘acceptation du maître d‘oeuvre',
        PROJECT_MANAGER_CLIENT: 'En attente de l‘acceptation du maître d‘oeuvre',
        SERVICE_PROVIDER: 'En attente de l‘acceptation du prestataire',
        SUB_CONTRACTOR: 'En attente de l‘acceptation du sous-traitant'
      }
    },
    organisationDeactivated: '(Entreprise désactivée)',
    removed: {
      removeSuccess: 'L‘entreprise %{organisationName} a bien été supprimée'
    },
    role: {
      CLIENT: 'Maitre d‘ouvrage',
      GENERAL_CONTRACTOR: 'Entreprise principale',
      PROJECT_MANAGER: 'Maître d‘oeuvre',
      PROJECT_MANAGER_CLIENT: 'Maître d‘oeuvre',
      SERVICE_PROVIDER: 'Prestataire',
      SUB_CONTRACTOR: 'Sous-traitant'
    }
  },
  invalidOrganisationDocuments: {
    emptyMessage: 'Aucun document invalide à afficher',
    title: 'Documents invalides'
  },
  invitation: {
    externalInvitationSuccessTitle: 'Invitation envoyée !',
    received: {
      actions: {
        accept: 'Accepter cette invitation',
        reject: 'Décliner cette invitation'
      },
      emptyList: 'Vous n‘avez aucune invitation à traiter',
      expandList: 'Voir toutes les invitations',
      message: {
        PROJECT_NOT_AUTOMATICALLY_ACCEPTED: 'Vous êtes invité à rejoindre l‘opération __s%{projectName}__s',
        RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'Vous êtes invité par __s%{invitingOrganisationName}__s à rejoindre son réseau en tant que fournisseur.',
        RELATIONSHIP_SUGGESTED: 'En tant que fournisseur, vous pourriez être intéressé de partager vos documents avec __s%{invitingOrganisationName}__s',
        USER_PENDING: 'L‘utilisateur __s%{firstName} %{lastName}__s a demandé à rejoindre votre entreprise.',
        projectInvitedBy: 'Invité par __s%{invitingOrganisationName}__s'
      },
      title: 'Invitations reçues'
    },
    sent: {
      clone: 'L‘utilisateur a enregistré l‘entreprise %{cloneRegistrationNumber} suite à votre invitation envoyée à l‘entreprise %{originalRegistrationNumber}',
      email: 'E-Mail',
      invitationSentDate: 'Envoyée le',
      noResult: 'Aucune invitation à afficher',
      resentOn: 'Renvoyée le %{date}',
      status: 'Statut',
      waitingForApproval: 'En attente de l‘acceptation du fournisseur',
      waitingForRegistration: {
        client: 'En attente de l‘inscription du client',
        subcontractor: 'En attente de l‘inscription du fournisseur'
      }
    },
    suggestion: {
      accept: 'Vous allez partager vos documents avec',
      actions: {
        accept: 'Vous allez partager vos documents avec %{invitingOrganisationName}',
        reject: 'Vous ne souhaitez pas partager vos documents avec %{invitingOrganisationName}'
      },
      expandList: 'Voir toutes les suggestions',
      reject: 'Vous ne souhaitez pas partager vos documents avec',
      rejectionReason: 'Sélectionnez un motif de déclinaison de la suggestion',
      rejectionSuccess: '[%{invitingOrganisationName} has been removed from your clients suggestions!]',
      title: 'Les suggestions sont basées sur les invitations que vous avez reçues par email destinées à (ou concernant) un établissement différent du vôtre'
    }
  },
  invite: {
    alreadyExists: {
      action: 'Ajouter',
      text: 'Vous pouvez dès à présent l‘ajouter',
      title: 'Cette entreprise est déjà enregistrée sur le réseau OnceForAll'
    },
    alreadyInvited: {
      text: 'Vous avez déjà envoyé une invitation à cette adresse email pour que cette entreprise soit ajoutée au réseau OnceForAll.',
      title: 'L‘invitation existe déjà'
    },
    cancel: 'Supprimer l‘invitation',
    cancelSuccessful: 'Votre invitation a été supprimée.',
    customMessage: 'Message',
    email: 'Adresse email',
    firstName: 'Prénom',
    inactive: {
      text: 'Veuillez contacter notre service client pour plus d‘informations.',
      title: 'Cette entreprise est inactive'
    },
    language: 'Langue',
    lastName: 'Nom',
    messageSectionSubtitle: 'Vous pouvez conserver le message pré-rempli ou le modifier',
    messageSectionTitle: 'Message de l‘invitation',
    organisationName: 'Entreprise',
    organisationSectionTitle: 'Quelle entreprise souhaitez-vous inviter ?',
    phoneNumber: 'Numéro de téléphone',
    unknown: {
      text: 'Vous pouvez l‘inviter à rejoindre le réseau OnceForAll.',
      title: 'Aucune entreprise portant ce numéro de SIRET ne semble exister'
    },
    userSectionTitle: 'À qui devons-nous adresser cette invitation ?'
  },
  invoices: {
    amountDue: 'Montant dû',
    amountTotal: 'Montant total',
    creationDate: 'Émise le %{date}',
    download: 'Télécharger la facture',
    dueOn: 'Date d‘échéance le %{date}',
    loadMore: 'Afficher les 10 factures suivantes',
    noResult: 'Aucune facture disponible',
    paidOn: 'Payée le %{date}',
    sentTo: 'Envoyée à',
    status: {
      NOT_PAID: 'À payer',
      PAID: 'Payée',
      PAYMENT_DUE: 'À payer',
      POSTED: 'À payer'
    },
    statusTitle: 'Statut',
    title: 'Factures'
  },
  language: {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    it: 'Italiano'
  },
  mandate: {
    details: {
      backToList: 'Retour à la liste des mandats',
      details: {
        certifyingThirdParty: 'Tiers attestant',
        creationDate: 'Date de création',
        documentType: 'Type de document',
        perimeter: {
          GROUP: 'Groupe',
          ORGANISATION: 'Établissement',
          label: 'Périmètre du mandat'
        },
        title: 'Détails',
        updateDate: 'Date de mise à jour'
      },
      editMessage: {
        broadcast: 'Pour modifier les détails du mandat de diffusion, merci de',
        collection: 'Pour modifier les détails du mandat de collecte, merci de'
      },
      information: {
        broadcast: 'Informations pour la diffusion',
        collection: 'Informations pour la collecte',
        copyToClipboard: 'Copier dans le presse-papier',
        showValue: 'Afficher la valeur',
        website: 'Site web'
      },
      title: {
        broadcast: 'Mandat de diffusion pour',
        collection: 'Mandat de collecte pour'
      }
    },
    field: {
      CONVENTION_NUMBER: 'Numéro de convention',
      EMAIL: 'Adresse électronique',
      FIRST_NAME: 'Prénom',
      INSURANCE_COMPANY: 'Compagnie - Agent - Courtier',
      KEY: 'Clé',
      LAST_NAME: 'Nom',
      LOGIN: 'Identifiant',
      PASSWORD: 'Mot de passe',
      PHONE: 'Numéro de téléphone',
      POLICE_NUMBER: 'Numéro de police',
      REGION: 'Région',
      REGISTRATION_NUMBER: 'SIRET',
      SOCIAL_SECURITY_NUMBER: 'Numéro de sécurité sociale'
    },
    list: {
      comment: 'Commentaire',
      creationDate: 'Date de création',
      message: {
        email: 'service.clients@onceforall.com',
        firstPart: {
          broadcast: {
            part1: 'Le mandat de diffusion est une option incluse dans votre abonnement et vous permet de nous confier la diffusion de vos documents(1) valides vers d‘autres plateformes. Avec le mandat de diffusion, vous vous concentrez sur votre business.',
            part2: '(1) La liste des salariés étrangers soumis à autorisation de travail ne peut pas être mise à jour. L‘attestation fiscale doit être éditée durant l‘année en cours. Les documents spécifiques demandés par les clients, non présents sur la plateforme OnceForAll, doivent être mis à jour par votre entreprise.'
          },
          collection: 'Le mandat de collecte est une option déjà incluse dans votre abonnement, à l‘exception de l‘offre Expérience, et vous permet de nous confier la mise à jour de vos documents sur Attestation Légale. Avec le mandat de collecte, vous vous concentrez sur votre business.'
        },
        link: 'cliquant ici',
        secondPart: 'Comment le mettre en place ? Téléchargez le document en ',
        thirdPart: ' et renvoyez le, complété et signé, à '
      },
      noResult: {
        broadcast: 'Aucun mandat de diffusion pour cette entreprise',
        collection: 'Aucun mandat de collecte pour cette entreprise'
      },
      platform: 'Platforme',
      subtype: 'Type du document',
      thirdParty: 'Tiers attestant',
      updateDate: 'Date de mise à jour'
    },
    planUpgradable: 'Vous devez changer d‘offre pour partager vos documents sur d‘autres plateformes.',
    platform: {
      AWS: 'AWS',
      EATTESTATIONS: 'e-Attestations',
      MYPROCUREMENT: 'MyProcurement',
      PROVIGIS: 'Provigis'
    },
    platformWebsite: 'Ouvrir le site web de la plateforme',
    thirdPartyGroup: {
      CIBTP: 'Congés Intempéries BTP - CIBTP',
      CNETP: 'Caisse Nationale des Entrepreneurs de Travaux Publics - CNETP',
      NET_ENTREPRISE: 'Net Entreprise',
      PROBTP: 'PRO BTP',
      TESE: 'Titre emploi service entreprise - TESE',
      URSSAF: 'URSSAF',
      URSSAF_AUTOENT: 'URSSAF Autoentrepreneur',
      URSSAF_INDEP: 'URSSAF Indépendant'
    },
    thirdPartyWebsite: 'Ouvrir le site web du tiers attestant'
  },
  menu: {
    bdr: 'Bâtisseur de Relations',
    clients: 'Clients',
    dashboard: 'Tableau de bord',
    documents: 'Documents',
    help: 'Aide et Contact',
    home: 'Tableau de bord',
    news: 'Actualités',
    panda: 'Accéder à PanDA',
    profile: 'Mon profil',
    projects: 'Opérations',
    settings: 'Paramètres',
    subcontractors: 'Fournisseurs',
    vitrine: 'Créer ma liste de références'
  },
  message: {
    changesSaved: 'Les modifications ont été enregistrées!',
    exportRequestSuccess: 'Votre demande a bien été enregistrée. Vous recevrez bientôt votre export par email.',
    lastUpdateDate: 'Date de dernière modification :',
    loading: 'Chargement en cours',
    missingPermission: 'Vous n‘avez pas la permission requise pour signer ce document',
    missingRequiredFields: 'Tous les champs obligatoires doivent être remplis',
    missingSelectedOrganisation: 'Vous devez sélectionner une entreprise',
    moreResults: '%{results} autres résultats',
    noData: 'Ces données ne sont pas encore disponibles',
    pageAccessDenied: 'Désolé, vous n‘avez pas accès à cette page.',
    pageNotFound: 'Désolé, la page que vous demandez est introuvable.',
    projectNotEditable: 'Pour modifier les champs désactivés, merci de',
    roleNotAllowed: 'Votre rôle ne vous permet pas d‘accéder à cette section. Merci de contacter le service commercial pour le modifier.',
    selectedOrganisationDenied: 'Vous n‘avez pas accès à cette entreprise, mais votre demande a été envoyée aux managers de l‘entreprise',
    textCounter: '%{counter} caractères sur %{maxLength}'
  },
  notification: {
    document: {
      atDate: 'Votre __s%{documentName}__s pour l‘année __s%{year}__s est manquante et requise pour __s%{projectsCount}__s opération(s). Veuillez déposer une version valide pour l‘année __s%{year}__s, s‘il vous plaît. Une fois déposé, ce fichier sera traité par notre équipe production sous 48h et apparaîtra ensuite sur la plateforme OnceForAll.',
      collectionMandateDisabled: {
        FRANCE: 'Le document %{documentName} n‘est plus collecté par Attestation Légale',
        GERMANY: 'Le document %{documentName} n‘est plus collecté par OnceForAll'
      },
      created: '%{documentName} a été ajouté dans votre dossier.',
      depositor: 'Vous pouvez désormais déposer des documents et les partager avec vos clients.',
      remind: '%{userFullName} vous rappelle de mettre à jour vos documents pour votre entreprise %{organisationName}',
      requalified: '%{previousDocumentName} a été renommé %{documentName} par notre équipe',
      validUntil: ' Il sera valide jusqu‘au %{expirationDate}.',
      validated: 'Le document %{documentName} a été validé par notre équipe.',
      yourDocument: 'Votre document __s%{documentName}__s'
    },
    emptyList: 'Vous avez traité toutes vos notifications',
    organisation: {
      automaticAcceptationEnabled: 'Vous acceptez les invitations automatiquement en tant que fournisseur. Vous pouvez modifier ce paramètre pour les accepter manuellement.',
      deactivation: {
        inviting: '%{organisationName} ne peut pas rejoindre votre réseau car cette entreprise a été désactivée.',
        relatedAsClient: '%{organisationName} a été désactivé. Vous pouvez toujours accéder à son dossier.',
        relatedAsSubcontractor: '%{organisationName} a été désactivé.'
      }
    },
    project: {
      accepted: 'Vous avez rejoint l‘opération %{projectName}',
      closed: 'L‘opération %{projectName} a été clôturée par l‘entreprise %{organisationOwnerName}. Vous pouvez toujours accéder aux documents relatifs à cette opération.',
      organisationEnded: 'Votre entreprise %{invitedOrganisationName} ne fait plus partie de l‘opération %{projectName}.',
      rejected: 'L‘entreprise %{invitedOrganisationName} a refusé de joindre l‘opération %{projectName} car : %{rejectionReason}',
      updatedRequiredDocumentsInProjectDossierOverview: 'Les documents requis pour le Quitus de l‘opération %{projectName} ont changé. '
    },
    relationship: {
      accepted: {
        AS_CLIENT: 'Vous avez rejoint le réseau de %{invitingOrganisationName} en tant que client',
        AS_SUBCONTRACTOR: 'Vous avez rejoint le réseau de %{invitingOrganisationName} en tant que fournisseur'
      },
      rejected: 'L‘entreprise %{invitedOrganisationName} a refusé de joindre votre réseau car : %{rejectionReason}'
    },
    user: {
      linked: '%{firstName} %{lastName} a rejoint  %{organisationName}.',
      permissionsUpdated: {
        MANAGE_PROJECT: {
          ADDITION: '%{firstName} %{lastName} peut maintenant gérer des opérations pour %{organisationName}',
          DELETION: '%{firstName} %{lastName} ne peut plus gérer d‘opérations pour %{organisationName}'
        },
        SIGN: {
          ADDITION: '%{firstName} %{lastName} peut maintenant signer des documents en ligne pour %{organisationName}',
          DELETION: '%{firstName} %{lastName} ne peut plus signer de documents en ligne pour %{organisationName}'
        }
      },
      roleUpdated: {
        CONSULTANT: '%{firstName} %{lastName} a maintenant le rôle Consultant pour %{organisationName}',
        EXPLORER: '%{firstName} %{lastName} a maintenant le rôle Exploreur pour %{organisationName}',
        INVITING: '%{firstName} %{lastName} a maintenant le rôle Invitant pour %{organisationName}',
        MANAGER: '%{firstName} %{lastName} a maintenant le rôle Manager de Compte pour %{organisationName}'
      }
    }
  },
  opera: {
    'platform-ACTRADIS': {
      message: 'Plateforme maître : ACTRADIS'
    },
    'platform-OFA': {
      message: 'Plateforme maître : OFA'
    }
  },
  organisation: {
    accessCode: {
      name: 'Code d‘accès',
      tooltip: 'Connectez-vous directement avec votre fournisseur avec le code qu‘il vous a éventuellement fourni'
    },
    businessLine: {
      AGRICULTURE: 'Agriculture',
      CLEANING: 'Nettoyage',
      CONSTRUCTION: 'BTP - Construction',
      MANUFACTURING: 'Industrie manufacturière',
      METAL_PRODUCTS: 'Fabrication de produits métalliques',
      OTHER: 'Autre secteur',
      PARCEL_DELIVERY: 'Livraison de colis',
      RENTAL_LEASING: 'Activités de location',
      SAFETY: 'Sécurité privée',
      SERVICE_ACTIVITIES: 'Activités de services',
      TEMPORARY_WORK: 'Travail temporaire',
      TRANSPORTATION: 'Transports',
      WASTE_MANAGEMENT: 'Gestion des déchets',
      title: 'Secteur d‘activité'
    },
    create: {
      cautionNotice: 'Si vous souhaitez déposer vos documents en ligne, assurez-vous de bien inscrire l‘établissement avec lequel vous avez contracté avec votre client.',
      errors: {
        sirenNotMatching: 'Le SIREN ne correspond pas au SIRET renseigné'
      },
      privacyPolicyAccepted: 'J‘ai lu et j‘accepte la politique de confidentialité *',
      requiredNotice: '* Champs obligatoires',
      step1: 'Étape 1',
      step1Text: 'Entrez le %{idNumberName} de votre entreprise',
      step2: 'Étape 2',
      step2Text: 'Vérifier ou compléter les informations',
      termsAccepted: 'J‘accepte les conditions d‘utilisation *',
      title: 'Renseigner mon entreprise'
    },
    createOrganisation: 'Sélectionner une entreprise',
    createOrganisationDeactivated: '%{organisationName} est désactivée. Vous ne pouvez pas rejoindre cette entreprise.',
    createOrganisationFound: 'Cette entreprise existe déjà sur OnceForAll. Cliquez sur "Continuer" pour la rejoindre.',
    createOrganisationFoundAndLinked: 'Cette entreprise existe déjà sur OnceForAll et vous êtes déjà lié à elle',
    createOrganisationFoundInILG: 'Cette entreprise n‘existe pas encore sur OnceForAll. Créez-la en cliquant sur "Continuer".',
    createOrganisationNotFound: 'Cette entreprise n‘est pas connue. Veuillez vérifier votre numéro SIRET.',
    createOrganisationSuccess: 'Votre organisation a été créée',
    deactivated: {
      title: 'Entreprise désactivée',
      tooltip: 'Cette entreprise est désactivée, vous ne pouvez pas la sélectionner.',
      tooltipBackOffice: 'Cette entreprise est désactivée.'
    },
    delete: {
      confirmDeleteOrganisation: {
        content: 'Êtes-vous sûr de vouloir supprimer %{organisationName}?',
        warning: {
          client: 'Cette entreprise ne verra plus vos documents.',
          subcontractor: 'Vous ne pourrez plus voir ses documents.'
        }
      },
      success: 'L‘entreprise %{organisationName} a bien été supprimée',
      title: 'Supprimer de ma liste',
      tooltip: 'Vous ne pouvez pas supprimer cette entreprise car vous partagez au moins une opération avec elle. Seul le propriétaire d‘une opération peut supprimer une organisation d‘une opération !'
    },
    depositorService: {
      noFile: 'Aucun fichier à télécharger',
      notActivated: 'Cette entreprise n‘est plus déposante.'
    },
    details: 'Détails de l‘entreprise',
    fullName: 'Raison sociale',
    inactive: 'Cette entreprise est inactive. Veuillez contacter notre service client pour plus d‘informations.',
    invite: 'Inviter l‘entreprise "%{input}" à rejoindre le réseau',
    registrationNumber: 'Numéro de SIRET',
    remainingUserAccounts: '%{count} utilisateurs restants',
    search: {
      alreadyClient: 'Cette entreprise fait déjà partie de vos clients',
      alreadyInvited: 'Vous avez déjà invité ce fournisseur',
      alreadyPartOfProject: 'Cette entreprise fait déjà partie de l‘opération',
      alreadySelected: 'Cette entreprise est déjà sélectionnée',
      alreadySubcontractor: 'Cette entreprise fait déjà partie de vos fournisseurs',
      inputLabel: 'Rechercher une entreprise',
      invite: {
        action: 'Inviter',
        text: 'Vous pouvez l‘inviter à rejoindre le réseau OnceForAll',
        title: 'Vous ne trouvez pas l‘entreprise que vous recherchez ?'
      },
      lastSelected: 'Dernières organisations consultées :',
      notfound: 'Cette entreprise n‘a pas encore de compte sur OnceForAll',
      placeholder: 'Raison sociale, SIREN, SIRET ou TVA intracommunautaire',
      self: 'Ne vous ajoutez pas vous-même !',
      specifySearch: 'Il y a peut-être plus de 10 résultats. Précisez votre recherche.'
    },
    selectOrganisation: {
      all: 'Toutes vos entreprises',
      showAll: 'Voir toutes les entreprises',
      title: 'Rechercher une entreprise'
    },
    users: {
      noResult: {
        line1: 'L‘utilisateur que vous recherchez n‘appartient pas à cette entreprise.',
        line2: 'Voulez-vous l‘inviter ?'
      },
      searchLabel: 'Rechercher un utilisateur',
      title: 'Utilisateurs'
    },
    viewDetails: 'Voir les détails',
    website: 'Site web'
  },
  organisationSetting: {
    cantEditMessage: 'Pour modifier les détails de l‘entreprise, merci de',
    cantModifyRole: 'Pour modifier le rôle et les permissions des utilisateurs, merci de',
    contactCustomerService: 'contacter le service client',
    detailsTitle: 'Profil de mon entreprise',
    mandates: {
      broadcast: {
        notDepositor: 'Le service déposant actif est requis pour accéder aux mandats de diffusion',
        notManager: 'Seul le manager de compte peut accéder aux mandats de diffusion',
        title: 'Mandats de diffusion'
      },
      collection: {
        notDepositor: 'Le service déposant actif est requis pour accéder aux mandats de collecte',
        notManager: 'Seul le manager de compte peut accéder aux mandats de collecte',
        title: 'Mandats de collecte'
      }
    },
    subscriptionAndInvoicesTabDisabled: 'Seul le manager de compte peut gérer la souscription et accéder aux factures',
    subscriptionAndInvoicesTitle: 'Offre et factures',
    upload: 'Déposer',
    uploadLogo: 'Déposer le logo de l‘entreprise',
    usersTitle: 'Utilisateurs'
  },
  pagination: {
    items: 'Elements',
    of: 'sur',
    to: 'à'
  },
  panda: {
    access: {
      confirm: 'Accéder à PanDA',
      text1: 'Vous souhaitez accéder à PanDA.',
      text2: 'La solution PanDA vous permet de simplifier et sécuriser le traitement de vos demandes d‘agrément.',
      text3: 'En quelques clics, dématérialisez tout le processus d‘agrément des sous-traitants intervenants sur vos chantiers.',
      text4: 'En savoir plus',
      text5: 'En cliquant sur "Accéder à PanDA", votre compte utilisateur et vos entreprises sur OnceForAll seront automatiquement synchronisées sur PanDA.'
    },
    discover: {
      cancel: 'Je ne souhaite pas gérer mes demandes d‘agrément via PanDA',
      cta: 'Découvrir PanDA',
      text1: '__sGérez les demandes d‘agrément en ligne.__s',
      text2: 'Vous avez créé et suivez votre opération sur la plateforme Once for All. Pourquoi ne pas dématérialiser également vos demandes d‘agrément avec la solution PanDA ?'
    }
  },
  plan: {
    actions: {
      add: 'Ajouter des options',
      contactUs: 'Nous contacter',
      upgrade: 'Devenir déposant'
    },
    currentPlan: 'Votre offre actuelle',
    free: 'GRATUIT',
    message: {
      upgradeSuccess: 'Votre changement d‘offre a été pris en compte. Vous allez être recontacté prochainement par le service client.'
    },
    modal: {
      additionalProjects: 'Opérations supplémentaires',
      additionalProjectsOption: 'paiement unique, durée illimitée',
      additionalUsers: 'Utilisateurs supplémentaires',
      depositorService: 'Permettre à tous mes clients d‘accéder à mes documents',
      title: 'Ajouter des options à l‘offre %{type}'
    },
    options: {
      projectInclude: 'Opérations incluses',
      userInclude: 'Utilisateurs inclus'
    },
    perMonth: '/ mois',
    specialPrice: '*19€ pour les petites entreprises'
  },
  project: {
    actionProjectClosed: 'Cette action est impossible car cette opération a été clôturée',
    additionalNotes: 'Description',
    additionalNotesInfo: 'Cette description est visible par toute entreprise participant à l‘opération',
    address: 'Adresse de l‘opération',
    backToDashboard: 'Retour au dashboard de l‘opération',
    backToProjects: 'Retour à la liste des opérations',
    buttonDocuments: {
      download: 'Télécharger le dossier opération',
      expand: {
        tooltip: 'Vous devez activer le service déposant pour voir votre liste de documents'
      },
      print: 'Imprimer le dossier opération',
      showDocuments: 'Afficher les documents'
    },
    close: 'Clôturer l‘opération',
    closeSuccess: 'Cette opération est maintenant clôturée.',
    closedProject: '(clôturée)',
    closingDate: 'Date de clôture',
    confirmProjectClosure: {
      content: 'Les statuts et documents des entreprises participantes restent accessibles.\nMais vous ne pourrez plus inviter de nouveaux participants à cette opération et toutes les invitations en cours seront annulées.',
      title: 'Êtes-vous sûr de vouloir clôturer cette opération ?',
      warning: 'Cette action est irréversible, une opération ne peut être rouverte !'
    },
    create: {
      button: 'Ajouter une nouvelle opération',
      creationSuccess: 'L‘opération %{name} a été créée!',
      projectCreditsTooltip: 'Vous n‘avez plus de crédit, merci de contacter le service client pour acheter de nouveaux crédits',
      title: 'Ajouter une nouvelle opération'
    },
    creditsNominative: '__s%{count}__s crédits opération nominative restants',
    creditsNominative_0: '__s%{count}__s crédit opération nominative restant',
    creditsNominative_1: '__s%{count}__s crédit opération nominative restant',
    creditsStandard: '__s%{count}__s crédits opération standard restants',
    creditsStandard_0: '__s%{count}__s crédit opération standard restant',
    creditsStandard_1: '__s%{count}__s crédit opération standard restant',
    description: {
      notice: 'Une fois cette opération créée, vous pourrez contacter le service client pour modifier ces informations',
      requiredNotice: '* Champs obligatoires',
      title: 'Description de l‘opération'
    },
    details: 'Détails',
    documentAtDateMessage: 'Le document déposé doit être valable à la date d‘ouverture de chantier : __s%{date}__s',
    documentAtInterventionDateMessage: 'Le document déposé doit être valable à la date de début d‘intervention : __s%{interventionDate}__s',
    documents: 'Documents',
    documentsStates: {
      ALMOST_EXPIRED: 'Bientôt expirés',
      MISSING: 'Manquants / Expirés / Rejetés',
      VALID: 'Valides'
    },
    documentsStillValid: 'encore valides',
    edit: {
      addOrganisation: 'Ajouter une entreprise',
      addOrganisationExternalSuccess: 'Une invitation a été envoyée à l‘entreprise %{name}',
      addOrganisationInternalSuccess: 'L‘entreprise %{name} a été invité à rejoindre l‘opération !',
      changeOrganisation: 'Changer l‘entreprise',
      changeRole: 'Changer le rôle',
      descriptionsPerRole: {
        CLIENT: '<span>Il s‘agit d‘une entreprise pour qui est réalisée l‘opération. Il s‘agit du Promoteur immobilier ou de la société créée spécifiquement pour l‘opération (SCCV, SCI, SNC, …).</span>',
        GENERAL_CONTRACTOR: '<span>Il s‘agit d‘une entreprise titulaire d‘un marché de travaux sur l‘opération. Cette société est en lien contractuel direct avec le Maître d‘ouvrage. On la nomme Entreprise Principale lorsque l‘opération est en « corps d‘état séparés » ou Entreprise Générale lorsque l‘ensemble des travaux toutes spécialités confondues lui sont attribués.</span>',
        PROJECT_MANAGER: '<span>Il s‘agit d‘une entreprise réalisant des études et ou apportant son assistance au Maître d‘ouvrage (bureau d‘études, architecte, …). Cette société est en lien contractuel direct avec le Maître d‘ouvrage.</span>',
        PROJECT_MANAGER_CLIENT: '<span>Il s‘agit d‘une entreprise réalisant des études et ou apportant son assistance au Maître d‘ouvrage (bureau d‘études, architecte, …). Cette société est en lien contractuel direct avec le Maître d‘ouvrage.</span>',
        SERVICE_PROVIDER: '<span>Il s‘agit d‘une entreprise réalisant des prestations pour le compte du Maitre d‘ouvrage, du Maître d‘oeuvre ou d‘une Entreprise Principale et dont les prestations ne participent pas directement à la constitution de l‘ouvrage. Elle est titulaire d‘un contrat de prestation.</span>',
        SUB_CONTRACTOR: '<span>Il s‘agit d‘une entreprise réalisant des travaux pour le compte d‘une Entreprise Principale ou d‘une Entreprise Générale. Elle est titulaire d‘un contrat de sous-traitance. En fonction de son rang d‘intervention, elle peut être en lien contractuel avec une Entreprise principale ou un Sous-traitant.</span>'
      },
      editDocuments: 'Appliquer les modifications',
      editProjectDescription: 'Modifier la description de l‘opération',
      editProjectDescriptionSuccess: 'L‘opération %{name} a été éditée!',
      editRequiredDocuments: 'Modifier les documents requis',
      externalInvitationSuccess: 'Une fois que la personne invitée se sera inscrite sur OnceForAll et qu‘elle aura ajouté son entreprise, cette dernière sera automatiquement ajoutée à l‘opération.',
      message: {
        EXTERNAL: 'Invitation via email',
        INTERNAL: 'Mise en relation'
      },
      notEditable: 'Vous devez d‘abord déposer le cahier des charges et/ou le CCRD afin de requérir ce document. Dès lors, le service client créera ce document dans les plus brefs délais.',
      organisation: 'Choisir une entreprise',
      requiredForDossierOverviewStatus: 'Requis pour le Quitus Opération',
      requiredForProject: 'Requis pour cette opération',
      roleAs: 'En tant que',
      roleType: 'Sélectionner un rôle',
      seeRequiredDocuments: 'Voir les documents requis',
      title: 'Ajouter une entreprise',
      warning: '<strong>Attention :</strong> Si vous modifiez la date d‘ouverture du chantier, toutes les attestations décennales à cette date seront recalculées. Veuillez être sûr de votre modification avant de valider, afin d‘éviter toute erreur.'
    },
    exportDossier: 'Exporter dossier opération',
    exportQuitus: 'Télécharger le rapport collectant de l‘opération',
    goToChart: 'Voir l‘organigramme',
    grantAccess: {
      button: 'Donner accès à cette opération',
      missing: 'Si vous ne trouvez pas l‘utilisateur dans la liste, vous pourrez l‘ajouter a posteriori en contactant votre manager de compte ou le ',
      missingLink: 'service client.',
      title: 'Donner accès à cette opération',
      user: {
        fullName: 'Nom',
        role: 'Rôle',
        viewProject: 'Accès opération'
      }
    },
    internalNotes: {
      author: 'Note de %{fullName}',
      creationDate: 'Publiée le ',
      newInternalNote: 'Nouvelle note interne',
      title: 'Notes internes'
    },
    internalReference: 'Référence interne',
    invite: {
      client: {
        defaultMessage: '%{userName} de la société %{organisationName} vous invite à rejoindre la plateforme OnceForAll d‘Attestation Légale dans le cadre de votre participation à l‘opération %{projectName} afin de faciliter la gestion de vos fournisseurs (Kbis, attestation sociale de vigilance, liste des salariés étrangers, etc.).\nLeader sur son marché, Attestation Légale a vocation à faciliter les relations entre les acteurs de la Construction et de l‘Immobilier. Grâce à la solution OnceForAll, vous accédez en toute sécurité aux dossiers uniques, toujours complets et à jour de vos fournisseurs.\nDès que vous serez inscrit, vous pourrez accéder gratuitement et à tout moment aux dossiers administratifs des sociétés participant à l‘opération %{projectName}.'
      },
      depositor: {
        defaultMessage: '%{userName} de %{organisationName} vous invite à rejoindre la plateforme OnceForAll d‘Attestation Légale dans le cadre de votre participation à l‘opération %{projectName} afin de simplifier et sécuriser la transmission régulière de vos attestations (Kbis, attestation sociale de vigilance, liste des salariés étrangers, etc.).\nGrâce à la solution OnceForAll, vous constituez en ligne votre dossier unique, toujours complet et à jour, disponible pour tous vos clients en quelques clics 7J/7 et 24h/24. Leader sur son marché, Attestation Légale facilite et sécurise les relations entre les acteurs de la Construction et de l‘Immobilier. Chaque semaine, 200 membres rejoignent notre communauté de plus de 46.000 acteurs de la filière.\nDès que vous serez inscrit et connecté à %{organisationName}, vous pourrez partager votre dossier en ligne à l‘ensemble de vos clients pour réellement et durablement simplifier vos échanges administratifs.'
      },
      title: 'Inviter une entreprise'
    },
    myProjects: 'Opérations',
    name: 'Nom de l‘opération',
    noProjects: 'Aucune opération trouvée',
    notifications: {
      cancel: 'Je l‘ai déjà fait',
      grantAccess: 'Avez-vous donné accès à vos collègues à l‘opération ?',
      requiredDocuments: 'Avez-vous défini les documents requis pour cet opération ?'
    },
    openingDate: 'Date de déclaration d‘ouverture de chantier (DOC)',
    organisationDocuments: 'Documents de l‘entreprise %{organisationName}',
    organisationHasNoDocuments: 'L‘entreprise n‘a aucun document',
    organisations: {
      notice: 'Vous pourrez modifier ces informations après la création de l‘opération',
      title: 'Entreprises'
    },
    ownerOrganisation: 'Propriétaire',
    participants: {
      description: 'participants dans l‘opération',
      title: 'Participants'
    },
    projectAccepted: 'L‘invitation à l‘opération a été acceptée !',
    projectAlreadyClosed: 'Cette opération est clôturée. Vous ne pouvez plus la rejoindre.',
    projectAlreadyReplied: 'Vous avez déjà répondu à cette invitation',
    projectClosedChip: 'Opération clôturée',
    projectInviterRemoved: 'Vous ne pouvez pas rejoindre cette opération car l‘entreprise qui vous a invité ne fait plus partie de l‘opération.',
    projectRejected: 'L‘invitation à l‘opération a été déclinée !',
    provisionalAcceptanceDate: 'Date de fin prévisionnelle',
    quitus: 'Quitus',
    quitusDescription: 'des participants au projet ont un quitus valide',
    requiredDocuments: {
      message1: '__sRequis pour cette opération__s : Les documents sélectionnés dans cette colonne seront collectés pour toutes les entreprises présentes sur l‘opération selon leur secteur d‘activité et leur pays.',
      message2: '__sRequis pour le Quitus Opération__s : Cette colonne vous permet de personnaliser le quitus opération. La validité de celui-ci sera calculée à partir des documents sélectionnés. Exemple : RIB opération coché dans Documents à collecter mais pas dans Requis pour le quitus opération : le RIB opération sera demandé à l‘entreprise mais n‘invalidera pas le quitus opération s‘il est manquant.',
      title: 'Documents requis',
      tooltip: {
        FOREIGN: 'Ce document est requis uniquement pour les entreprises étrangères et les succursales',
        businessLines: 'Ce document est requis uniquement pour les entreprises des secteurs d‘activités suivants : ',
        businessLines_1: 'Ce document est requis uniquement pour les entreprises du secteur d‘activités suivant : '
      }
    },
    roleForm: {
      change: 'Changer de rôle',
      choose: 'Choisir ce rôle',
      client: {
        firstPoint: 'Voir l‘ensemble des entreprises participant à l‘opération',
        intro: 'Créer une opération en tant que __sMaitre d‘ouvrage__s permet de :',
        secondPoint: 'Inviter uniquement des entreprises principales',
        thirdPoint: 'Accéder aux documents de toutes les entreprises de l‘opération'
      },
      generalContractor: {
        firstPoint: 'Voir les entreprises participant à l‘opération',
        intro: 'Créer une opération en tant que __sEntreprise principale__s permet de :',
        secondPoint: 'Inviter les entreprises à l‘opération (Maitre d‘ouvrage, entreprises principales, sous-traitants)',
        thirdPoint: 'Accéder aux documents de vos sous-traitants'
      },
      notice: 'Veuillez sélectionner le rôle de __s%{organisationName}__s dans cette opération',
      projectManagerClient: {
        firstPoint: 'Voir l‘ensemble des entreprises participant à l‘opération',
        intro: 'Créer une opération en tant que __sMaitre d‘oeuvre__s permet de :',
        secondPoint: 'Inviter les entreprises à l‘opération (Maitre d‘ouvrage, entreprises principales, vos sous-traitants)',
        thirdPoint: 'Accéder aux documents de toutes les entreprises de l‘opération'
      },
      title: 'Rôle dans l‘opération'
    },
    search: {
      notfound: 'Cette opération n‘existe pas',
      placeholder: 'Nom de l‘opération'
    },
    selectIntervention: {
      invitedBy: 'Invité par %{invitingOrganisationName}',
      message: 'Votre entreprise a plusieurs rôles dans cette opération, veuillez sélectionner le rôle avec lequel vous souhaitez consulter cette opération.',
      title: 'Sélectionner le rôle'
    },
    showInvalidDocumentsPage: 'Voir documents invalides',
    subcontractors: {
      description: 'sous-traitants dans l‘opération',
      title: 'Sous-traitants'
    },
    tree: {
      title: 'Organigramme',
      clients: 'Maîtrise d‘ouvrage',
      projectManagers: 'Maîtrise d‘oeuvre',
      supplyChain: 'Chaîne de sous-traitance'
    },
    type: {
      NOMINATIVE: 'Nominative',
      STANDARD: 'Standard'
    },
    typeForm: {
      NOMINATIVE: {
        fifthPoint: 'Avoir une vérification documentaire dédiée pour l‘opération',
        firstPoint: 'Mettre à disposition un espace dédié à l‘opération',
        fourthPoint: 'Collecter des documents spécifiques : Attestation Décennale Nominative (pour les chantiers dont le coût est supérieur à 15 000 000 euros) ; Charte RSE ; Compte rendu inspection commune CSPS ; PPSPS : Plan particulier de sécurité et de protection de la santé ; Liste du personnel Nominative',
        intro: 'Créer une opération de type Nominative permet de :',
        secondPoint: 'Gérer la chaîne de sous-traitance',
        thirdPoint: 'Piloter le chantier grâce au tableau de bord'
      },
      STANDARD: {
        firstPoint: 'Mettre à disposition un espace dédié à l‘opération',
        intro: 'Créer une opération de type Standard permet de :',
        secondPoint: 'Gérer la chaîne de sous-traitance',
        thirdPoint: 'Piloter le chantier grâce au tableau de bord'
      },
      change: 'Changer de type',
      choose: 'Choisir ce type',
      notice: 'Veuillez sélectionner le type d‘opération que vous souhaitez créer',
      title: 'Type d‘opération'
    },
    upgradeToNominative: {
      title: 'Convertir en opération nominative',
      tooltip: 'Il n‘y a pas suffisamment de crédits opération nominative'
    },
    viewDetails: 'Voir les détails'
  },
  registerFirstTime: {
    import: 'Télécharger et partager vos documents',
    joinOrganisation: 'Rejoindre une entreprise déjà existante sur OFA',
    joinOrganisationSubtitle: 'Utiliser le numéro de SIRET de votre entreprise',
    network: 'Développer votre réseau',
    newOrganisation: 'Vous pouvez inscrire une nouvelle entreprise',
    newOrganisationSubtitle: 'Munissez-vous des informations de votre entreprise pour démarrer !',
    optionsTitle: 'Votre entreprise n‘est pas encore sur OnceForAll ?',
    participate: 'Participer à des opérations',
    start: 'Veuillez cliquer ci-dessous pour commencer !',
    startButton: 'Inscrire votre entreprise',
    subtitle: 'Avec nous, vous pouvez :',
    title: 'Première connexion sur OFA ?',
    view: 'Consulter les documents de vos fournisseurs'
  },
  rejectionReason: {
    displayLabel: 'Invitation déclinée: ',
    label: 'Sélectionnez un motif de rejet',
    reason: {
      ACTRADIS_MEMBER: 'Déjà adhérent à la plateforme Actradis.',
      ALREADYACTIVECUSTOMER: 'Entreprise en cours d‘inscription ou déjà inscrite.',
      ALREADYMEMBEROFAFREEPLATFORM: 'Déjà adhérent à une plateforme gratuite.',
      CESSATIONOFACTIVITY: 'Entreprise en cessation d‘activité.',
      CESSATION_OF_ACTIVITY: 'Entreprise en cessation d‘activité.',
      DOINVITATIONERROR: 'L‘invitation concerne un client et non un fournisseur.',
      DO_INVITATION_MISTAKE: 'L‘invitation concerne un client et non un fournisseur.',
      FILE_ALREADY_TRANSMITTED: 'A déjà transmis ses documents.',
      FREE_PLATFORM_MEMBER: 'Déjà adhérent à une plateforme gratuite.',
      INCORRECTCONTACTDETAILS: 'Les coordonnées transmises sont erronées.',
      INSCRIPTION_ONGOING: 'Entreprise en cours d‘inscription ou déjà inscrite.',
      INSUFFICIENT_CUSTOMERS_NUMBER: 'Collabore avec très peu d‘entreprises.',
      KEEP_SENDING_FILE_BY_EMAIL: 'Souhaite échanger ses documents par e-mail ou par courrier.',
      NOBUDGET: 'Ne souhaite pas payer un abonnement.',
      NOLONGERRESPONDING: 'N‘a pas pu être joint malgré plusieurs tentatives.',
      NOT_INFORMED: 'Semble ne pas avoir pas été informé de la démarche.',
      NOT_MANDATORY: 'La démarche n‘est pas contractuelle.',
      NOT_WORKING_WITH_ORGANISATION: 'Je ne travaille pas avec cette entreprise',
      NO_ACTIVE_CONTRACT: 'Je n‘ai pas de contrat en cours avec ce client',
      NO_FILE_SHARING_WANTED: 'Ne pense pas mutualiser son dossier avec d‘autres clients',
      NO_LONGER_WORKING_WITH_ORGANISATION: 'Je ne travaille plus avec cette entreprise',
      NO_REASON_GIVEN: 'N‘a pas souhaité communiquer les raisons de sa décision.',
      PLATFORM_SECURITY_SCEPTIC: 'Doute de la sécurité de la plateforme.',
      PRICE: 'Ne souhaite pas payer un abonnement.',
      PRICETOOHIGH: 'Ne souhaite pas payer un abonnement.',
      SUBJECT_STUDIED_BY_MANAGEMENT: 'Le sujet est à l‘étude au niveau du siège ou de la direction.',
      UNDERREVIEW: 'Le sujet est à l‘étude au niveau du siège ou de la direction.',
      UNKNOWN_CLIENT: 'Je ne connais pas ce client',
      UNKNOWN_ORGANISATION: 'Je ne connais pas cette entreprise',
      UNREACHABLE: 'N‘a pas pu être joint malgré plusieurs tentatives.',
      WORKS_WITH_ANOTHER_ORGANISATION: 'Ce client travaille avec une autre de mes entreprises',
      WRONG_CONTACT_INFORMATIONS: 'Les coordonnées transmises sont erronées.'
    },
    title: 'Invitation de %{invitingOrganisationName}'
  },
  relationship: {
    errorDepositorService: 'Vous devez changer d‘offre pour gérer les invitations envoyées par vos clients.'
  },
  resendInvitationReason: {
    explanatory: 'Veuillez indiquer pourquoi vous souhaitez relancer l‘invitation',
    placeholder: 'Je relance l‘invitation car ...',
    reason: 'Motif',
    title: 'Inviter à nouveau'
  },
  settings: {
    collectorNotifications: 'Rapports hebdomadaires',
    collectorNotificationsMention: 'En vous abonnant, vous recevrez les rapports hebdomadaires par email.\nUn rapport hebdomadaire regroupe le statut des quitus de tous vos fournisseurs.',
    invitation: {
      priorAcceptation: {
        label: 'J‘accepte de partager mes documents avec mes clients sans acceptation préalable de ma part',
        notDepositor: 'Vous ne pouvez pas modifier ce paramètre si vous ne déposez pas de documents sur OnceForAll',
        notManager: 'Vous n‘avez pas les droits suffisants pour modifier ce paramètre'
      },
      title: 'Confidentialité'
    },
    mySettings: 'Paramètres',
    subscribeTo: {
      COLLECTOR_EVENT: 'Abonnez-vous au notification sur évènement',
      COLLECTOR_EVENT_PROJECT: 'Abonnez-vous au notification sur évènement par opération',
      COLLECTOR_PERIODIC: 'Abonnez-vous au rapport hebdomadaire',
      COLLECTOR_PERIODIC_PROJECT: 'Abonnez-vous au rapport hebdomadaire par opération'
    },
    tooltip: {
      COLLECTOR_PERIODIC: 'Vous n‘avez pas de fournisseurs !',
      COLLECTOR_PERIODIC_PROJECT: 'Vous n‘avez aucune opération !'
    }
  },
  signature: {
    canceledMessage: 'La signature du document a bien été refusée.',
    successMessage: 'Le document a été signé avec succès.'
  },
  subcontractor: {
    accessCode: {
      download: 'Télécharger le code d‘accès',
      label: 'Renseigner un code d‘accès',
      modal: {
        errorNotFound: 'Ce code d‘accès n‘existe pas ou a déjà été utilisé.',
        message: 'Merci d‘indiquer votre code d‘accès afin d‘avoir accès au dossier du fournisseur.',
        title: 'Renseigner un code d‘accès'
      },
      success: 'Le fournisseur a été ajouté à votre liste !'
    },
    add: {
      addSuccess: 'L‘entreprise %{name} a été ajoutée à votre liste de fournisseurs !',
      button: 'Ajouter un fournisseur',
      inviteSuccess: 'Invitation envoyée. En attente de l‘acceptation du sous-traitant %{name}',
      title: 'Ajouter un fournisseur'
    },
    archives: 'Archives',
    documents: 'Documents',
    export: 'Exporter le dossier de mes fournisseurs',
    invitations: {
      sent: 'Invitations envoyées'
    },
    invite: {
      defaultMessage: '%{userName} de %{organisationName} vous invite à rejoindre la plateforme Once For All - Attestation Légale afin de faciliter et sécuriser la transmission régulière de vos attestations (Kbis, attestation sociale de vigilance, liste des salariés étrangers, etc.).\nVous pouvez ainsi constituer en ligne votre dossier unique, toujours complet et à jour, disponible pour tous vos clients en quelques clics 7j/7 et 24h/24. Leader sur son marché, Once For All - Attestation Légale développe et fiabilise les relations entre les acteurs de la construction et de l‘immobilier. Chaque semaine, 200 membres rejoignent notre réseau de plus de 127 000 acteurs de la filière.\nDès que vous serez inscrit et connecté à %{organisationName}, vous pourrez partager votre dossier à l‘ensemble de vos clients pour réellement et durablement simplifier vos échanges administratifs.',
      inviteSuccess: 'Une fois que la personne invitée se sera inscrite sur OnceForAll et qu‘elle aura ajouté son entreprise, cette dernière sera automatiquement liée à la vôtre en tant que fournisseur.',
      reinviteDefaultMessage: '%{userName} de %{organisationName} vous invite à rejoindre de nouveau la plateforme OnceForAll d‘Attestation Légale afin de simplifier la gestion de vos documents.\nEn tant qu‘un de ses fournisseurs, vous donnerez à %{userName} un accès aux documents que vous déposez sur la plateforme OnceForAll.\nDans le cas où vous avez déjà utilisé la plateforme OnceForAll, il vous suffit de cliquer sur le bouton ci-dessous puis de choisir l‘offre qui vous convient le mieux.',
      resendSuccess: '%{name} a été invitée à nouveau!',
      title: 'Inviter un fournisseur'
    },
    mySubcontractors: 'Fournisseurs',
    projects: 'Opérations',
    reinvite: {
      action: 'Ré-inviter',
      text: 'Afin qu‘il puisse mettre à jour ses documents, invitez le à rejoindre de nouveau le réseau OnceForAll en cliquant sur le bouton ci-dessus.',
      title: 'Ce fournisseur n‘est plus actif sur la plateforme',
      tooltip: 'Inviter ce fournisseur à rejoindre de nouveau le réseau OnceForAll'
    },
    reminders: 'Relances',
    search: {
      notFound: 'Aucun fournisseur trouvé'
    }
  },
  subscription: {
    collector: 'Collectant',
    collector_and_depositor: 'Collectant et déposant',
    help: {
      firstPart: 'Vous trouverez sur ',
      link: 'cette page',
      secondPart: ' plus de détails sur le calcul du nombre de clients.'
    },
    nbClients: 'Vous partagez vos documents avec __s%{count}__s clients.',
    noResult: 'Vous devez contacter votre Manager de compte afin d‘en savoir plus sur les détails de votre souscription',
    remainingNominativeProjects: '__s%{count}__s crédits opération nominative restants',
    remainingStandardProjects: '__s%{count}__s crédits opération standard restants',
    remainingUserAccounts: '__s%{count}__s utilisateurs restants',
    title: 'Offre en cours',
    validUntil: 'Offre valide jusqu‘au __s%{date}__s'
  },
  subscriptions: {
    plans: {
      actualPlan: 'OFFRE EN COURS',
      clientOrganisations: 'Pour les donneurs d‘ordres',
      collectDocuments: 'JE COLLECTE DES DOCUMENTS',
      currency: {
        EUR: '€'
      },
      customerServiceMessage: 'Pour plus d‘information, contactez notre service commercial.',
      fee: '* %{price} de frais d‘inscription la première année',
      fee_0: 'Sans frais d‘inscription',
      free: 'Gratuit',
      offer: 'Offre',
      option: 'En option',
      or: 'soit ',
      pricePeriod: {
        month: '__c%{count}__c HT/mois',
        none: '__c%{count}__c HT',
        year: '__c%{count}__c HT/an'
      },
      seeMore: 'En savoir plus',
      services: {
        de_cie_registration_purchase_v1: 'Achat de votre HR-Auszug 1 fois par an',
        de_document_auth_v1: 'Vérification et authentification de vos documents',
        de_illimited_hotline_v1: 'Accès illimité à notre service clients',
        de_included_clients_v1: 'Diffusion de vos documents à %{count} clients maximum',
        de_online_dossier_v1: '__sConformité__s : Gestion de votre dossier en ligne. Dépôt des documents, archivage (pendant 15 ans), alertes préventives, signature électronique',
        de_unlimited_clients_v1: 'Diffusion illimité de vos documents à vos clients',
        fr_document_auth_v1: 'Vérification et authentification de vos documents',
        fr_illimited_hotline_v2: 'Accès illimité à notre service clients',
        fr_included_broadcasting_mandate_v1: '__sDiffusion de votre dossier sur d‘autres plateformes__s du marché : e-Attestations, MyProcurement, Provigis, AWS',
        fr_included_collection_mandate_v1: '__sMandat de collecte :__s nos équipes collectent à votre place vos attestations auprès des organismes concernés',
        fr_included_onceforall_platforms_v1: 'Diffusion de votre dossier sur le réseau Once for All : Actradis, Déclarations Légales, Hiveo',
        fr_kbis_purchase_v1: 'Achat de votre Kbis 4 fois par an',
        fr_limited_clients_v1: 'Diffusion de vos documents à __s%{count} clients maximum__s',
        fr_online_dossier_v1: '__sConformité__s : Gestion de votre dossier en ligne. Dépôt des documents, archivage (pendant 15 ans), alertes préventives, signature électronique',
        fr_unlimited_clients_v1: 'Diffusion illimité de vos documents à vos clients',
        fr_free_bdr: '__sBâtisseur de Relations__s : Accès à de nouvelles opportunités commerciales publiques et privées, référencement et visibilité sur notre réseau',
        it_document_auth_v1: 'Vérification et authentification de vos documents',
        it_illimited_hotline_v1: 'Accès illimité à notre service clients',
        it_online_dossier_v1: '__sConformité__s : Gestion de votre dossier en ligne. Dépôt des documents, archivage (pendant 15 ans), alertes préventives, signature électronique',
        it_unlimited_clients_v1: 'Diffusion illimité de vos documents à vos clients'
      },
      shareDocuments: 'JE DÉPOSE DES DOCUMENTS',
      smallOrganisations: 'Pour les entreprises de %{count} salariés maximum',
      subscribe: 'Souscrire',
      title: {
        de_basic_1y_v1: 'Basique',
        de_oncefor2_1y_v1: 'OnceFor2',
        de_onceforall_1y_v1: 'OnceForAll',
        fr_collector_sme_1y_v1: 'Collectant PME',
        fr_essential_v1: 'OFFRE ESSENTIEL',
        fr_experience_v1: 'OFFRE EXPÉRIENCE',
        fr_horizon_v1: 'OFFRE HORIZON',
        fr_liberty_v1: 'OFFRE LIBERTÉ',
        fr_essentialbdr: 'BUSINESS ESSENTIEL',
        fr_experiencebdr: 'BUSINESS EXPÉRIENCE',
        fr_horizonbdr: 'BUSINESS HORIZON',
        fr_libertybdr: 'BUSINESS LIBERTÉ',
        fr_onceforeignbdr: 'BUSINESS ONCE FOREIGN',
        fr_oncefor2_1y: 'ONCEFOR2',
        fr_onceforall_1y: 'ONCEFORALL',
        fr_onceforeign_1y: 'Once Foreign',
        fr_onceforever_1y: 'ONCEFOREVER',
        fr_onceformore_1y: 'ONCEFORMORE',
        it_basiccollector_V1: 'Basic',
        it_onceforall_1y: 'OnceForAll',
        it_onceforeign_1y: 'OnceForeign'
      },
      unit: {
        project: ' / opération',
        user: ' / utilisateur'
      }
    },
    questions: {
      shareCompliance: {
        title: 'Voulez-vous partager vos informations de conformité ?',
        response: {
          yes: 'Oui',
          no: 'Non'
        }
      },
      nbOfClients: {
        title: 'Avec combien de clients ?',
        response: {
          info: 'Séléctionner le nombre de clients',
          twoClients: 'Jusqu‘à 2 Clients',
          twentyClients: 'Jusqu‘à 20 Clients',
          fiftyClients: 'Jusqu‘à 50 Clients',
          moreThanFiftyClients: '51 clients et plus'
        }
      }
    },
    title: 'Les offres adaptées à votre entreprise'
  },
  textsToValidate: {
    accept: {
      privacyPolicy_1: 'Je reconnais avoir lu et accepter la ',
      privacyPolicy_2: 'Politique de Confidentialité',
      required: '.*',
      termsAndConditions_1: 'Je reconnais avoir lu et accepter les ',
      termsAndConditions_2: 'Conditions Générales de Vente ',
      termsAndConditions_3: 'et les ',
      termsAndConditions_4: 'Conditions Générales d‘Utilisation'
    },
    button: 'Accepter',
    privacyPolicy: 'Politique de confidentialité',
    subtext: 'Nous vous invitons à prendre connaissance de ces documents et les valider avant l‘utilisation de nos services. Nous restons à votre écoute pour toute précision.',
    termsAndConditions: 'Conditions générales de vente',
    termsOfUse: 'Conditions générales d‘utilisation',
    text: 'La principale évolution réside dans leur simplification et la séparation en deux textes distincts afin de vous en faciliter la lecture et la compréhension :',
    title: 'Votre plateforme évolue, les Conditions Générales qui l‘accompagnent également.',
    tooltip: 'Cliquez pour ouvrir le texte dans un nouvel onglet'
  },
  uploadImage: {
    errorTypeMessage: 'Le format de votre image n‘est pas correct.'
  },
  uploadLogo: {
    dragDropHere: 'Glisser et déposer ici votre logo (png, jpg, jpeg)',
    title: 'Logo de l‘entreprise',
    uploadSuccess: 'Votre logo a bien été mis à jour'
  },
  user: {
    account: 'Informations personnelles',
    actions: {
      untieUser: 'Supprimer son accès'
    },
    add: 'Ajouter un utilisateur',
    canNotUpdateProfile: 'Pour modifier votre profil, veuillez ',
    canNotUpdateProfileLinkText: 'contacter le service client.',
    changeEmailAddress: 'Changer votre adresse email',
    changeEmailButton: 'Changer l‘adresse email',
    deactivatedUser: 'L‘utilisateur %{firstname} %{lastname} a été désactivé',
    domainNameAutomaticTieUser: 'Les utilisateurs ayant pour adresse email __s%{domainName}__s peuvent automatiquement accéder à cette entreprise avec le rôle __sExploreur__s.',
    email: 'Email',
    emailChanged: 'Un email de confirmation vous a été envoyé à l‘adresse %{newEmail}',
    emailConfirmation: 'Confirmer l‘email',
    firstName: 'Prénom',
    formTitle: 'Inscrivez-vous sur OnceForAll',
    invite: {
      alreadyInvited: 'Cet utilisateur est déjà invité',
      alreadyPartOfOrganisation: 'Cet utilisateur a déjà accès à votre entreprise.',
      alreadySelected: 'Cet utilisateur est déjà sélectioné',
      button: 'Inviter un utilisateur',
      deactivatedUser: 'Cet utilisateur est désactivé',
      defaultMessage: 'Vous avez été invité par %{userName} à rejoindre %{organisationName} sur la plateforme OnceForAll via le lien suivant :',
      defaultUserMessage: 'Vous avez été invité par %{userName} de %{invitingOrganisationName} (%{invitingOrganisationRegistrationNumber}) à rejoindre  %{invitedOrganisationName} (%{invitedOrganisationRegistrationNumber}) sur la plateforme OnceForAll via le lien suivant :',
      orgaDeactivated: 'Cette entreprise est désactivée, vous ne pouvez pas inviter un utilisateur à la rejoindre.',
      orgaNonDepositor: 'Cette entreprise n‘est plus déposante, vous ne pouvez pas inviter un utilisateur à la rejoindre.',
      panelTitle: 'Inviter un utilisateur à rejoindre cette entreprise',
      self: 'Ne vous ajoutez pas vous-même !',
      successMessage: 'Vous avez invité %{count} utilisateurs à rejoindre votre entreprise',
      successMessage_1: 'Vous avez invité %{name} à rejoindre votre entreprise',
      successfullyInvitedUserToRelationship: 'Vous avez invité %{name} à rejoindre l‘entreprise %{organisationName}',
      title: 'Inviter un utilisateur dans votre entreprise',
      userAlreadyTiedToOrganisation: 'Cet utilisateur a déjà accès à cette entreprise'
    },
    language: 'Langue',
    lastName: 'Nom',
    manageProject: 'Gestion des opérations',
    maxUsersReached: 'Nombre maximal d‘utilisateurs atteint !',
    missingSubscription: 'Cette action est impossible car l‘entreprise n‘est rattachée à aucune souscription.',
    mobilePhoneNumber: 'Numéro de portable',
    myProfile: 'Données',
    notSelectedWarning: 'Vous devez inviter un utilisateur pour confirmer.',
    options: {
      COLLECTOR_PERIODIC_PROJECT_REPORT: 'J‘accepte de recevoir par courriel le rapport collectant par opération',
      SUGGESTION_DISPLAY: 'J‘accepte que des clients potentiels avec qui partager mon dossier me soient suggérés',
      title: 'Options'
    },
    password: 'Mot de passe',
    passwordConfirmation: 'Confirmer le mot de passe',
    phoneNumber: 'Numéro de téléphone',
    position: 'Poste',
    registrationDate: 'Date d‘inscription',
    role: 'Rôle',
    roles: {
      CONSULTANT: 'Consultant',
      EXPLORER: 'Exploreur',
      INVITING: 'Invitant',
      MANAGER: 'Manager de Compte'
    },
    securePasswordPolicy: {
      atLeast1Digit: 'Au moins 1 chiffre',
      atLeast1Lowercase: 'Au moins 1 minuscule',
      atLeast1Uppercase: 'Au moins 1 majuscule',
      atLeast8Characters: 'Au moins 8 caractères',
      tooltip: 'Utilisez au moins 8 caractères avec au moins 1 minuscule, 1 majuscule et 1 chiffre'
    },
    sign: 'E-signature',
    title: 'Ajouter un utilisateur à votre entreprise',
    updateButton: 'Confirmer'
  },
  vitrine: {
    access: {
      confirm: 'Créer ma liste de références',
      text1: '__sDigitalisation de la liste de références chantiers__s',
      text2: 'Découvrez comment créer et télécharger votre liste de références chantiers à partir de la plateforme OnceForAll.',
      text3: 'Via notre interface en ligne, vous pouvez saisir toutes les informations concernant vos références, ajouter des photos et exporter une liste au format le plus approprié.',
      text4: '__sGagnez du temps sur vos réponses à des appels à projets__s grâce à cette fonctionnalité qui vous permet de __scentraliser vos références sur une plateforme unique et de valoriser vos savoir-faire et réalisations.__s',
      text5: 'En savoir plus',
      text6: 'En cliquant sur "Créer ma liste de références", votre compte utilisateur et vos entreprises sur OnceForAll seront automatiquement synchronisés.'
    },
    discover: {
      cancel: 'Je ne souhaite pas créer ma liste de références',
      cta: 'TESTEZ MAINTENANT',
      text1: '__sNOUVEAU : Créez et téléchargez votre liste de références chantiers en quelques clics__s',
      text2: 'Centralisez vos références - Valorisez vos savoir-faire et réalisations - Gagnez du temps'
    }
  }
};
